const ADMIN_ROLES_ALL = (state, repsonse) => {
  if (repsonse.code == 1) {
    state.adminRoles = repsonse.data
  } else {
    alert('algo salio mal')
  }
}

export default{
  ADMIN_ROLES_ALL
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/roles/mutations.js